import LoyaltySpec from "../components/loyaltyManagement/loyaltySpec/LoyaltySpec";
import ResponsiveContentWrapper from "../components/layout/ResponsiveContentWrapper";

const LoyaltySpecPage = () => {
  return (
    <ResponsiveContentWrapper>
      <LoyaltySpec />
    </ResponsiveContentWrapper>
  );
};

export default LoyaltySpecPage;
